import { TariffChangeTable } from "@components/tables";

const PaymentTariffManage: React.FC = () => {
  return <TariffChangeTable />;
};

export default PaymentTariffManage;
